export enum DocumentsSectionType {
  Client = "Client",
  Collaborator = "Collaborator"
}
